







































import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import { ApiGeneralSinglePayload, CodeLabel } from '@/tcw/api/types'
import { KEY_CLASS_GYOUSHU_CODE } from '@/tcw/constant/KeyClass'
import { TcwFormID } from '@/tcw/domain/types'
import _ from 'lodash'

@Component
export default class KintaiPatternCard extends Mixins(BaseComponent) {
  @Prop({
    default: () => {
      /** */
    }
  })
  protected pattern!: ApiGeneralSinglePayload
  @Prop({ type: Boolean, default: false })
  protected deletable!: boolean

  @Emit()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected deletePattern(patternId: TcwFormID): void {
    /**  */
  }

  private gyoushuList: CodeLabel[] = []

  protected async getMasterData(): Promise<void> {
    //業種コードの取得
    this.gyoushuList = await this.codeLabel.getCodeLabelList(KEY_CLASS_GYOUSHU_CODE)
  }
  protected openEdit(patternId: TcwFormID): void {
    this.$router.push(`/pattern/kintai/${patternId}`)
  }
  
}
